<template>
  <div class="row">
    <div class="col-3 p-0 bg-white border-right">
      <client-list :clients="clients" :client="client">
      </client-list>
    </div>
    <div class="col-9 p-0 bg-light client-detail">
      <client-detail :client="client"></client-detail>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find'

import ClientList from '@/components/clients/ClientList.vue'
import ClientDetail from '@/components/clients/ClientDetail.vue'
import store from '@/stores/clients'
import client from '@/libs/client'

export default {
  name: 'clients',
  components: {
    ClientList,
    ClientDetail,
  },

  created() {
    client.all().then(res => {
      store.setClients(res.data.clients)
    })
  },

  computed: {
    client() {
      if(parseInt(this.$route.params.id)) {
        return find(store.state.clients, { id: parseInt(this.$route.params.id) }) || {}
      } else {
        return {}
      }
    },

    clients() {
      return store.state.clients
    }
  },

  methods: {

  }
}
</script>

<style scoped>
.client-detail {
  height: calc(100vh - 48px);
  overflow-y: auto;
}
</style>